import { Component, OnInit, ViewChild } from '@angular/core';
import { PaginationDTO } from 'src/app/common/types/responses/responses-template';
import { ProformPreviewModalComponent } from 'src/app/private/shared/components/modals/proform-preview-modal/proform-preview-modal.component';
import { ProformsAdminService } from 'src/app/private/shared/services/proforms/proforms-admin.service';
import { ProformsFormListService } from 'src/app/private/shared/services/proforms/proforms-formlist.service';
import {
  GetAllProFormsAPIResponse,
  ProFormsAPIResponse,
} from 'src/app/private/shared/types/responses/proforms.responses';

@Component({
  selector: 'app-onboarding-proforms-page',
  standalone: false,
  templateUrl: './onboarding-proforms-page.component.html',
  styleUrl: './onboarding-proforms-page.component.scss',
})
export class OnboardingProformsPageComponent implements OnInit {
  @ViewChild('previewModal')
  previewModal: ProformPreviewModalComponent;

  pagination: PaginationDTO;

  currentPage = 1;

  isLoading = true;

  forms: ProFormsAPIResponse[];

  searchTerm: string;

  searchTimeout: ReturnType<typeof setTimeout>;

  constructor(
    private proformsFormListService: ProformsFormListService,
    private proformsAdminService: ProformsAdminService
  ) {}

  ngOnInit(): void {
    this.loadProForms();
  }

  loadProForms(): void {
    this.proformsFormListService
      .getFormsOnboarding(2, 10, this.currentPage)
      .subscribe((resp: GetAllProFormsAPIResponse) => {
        if (resp.items) {
          this.forms = resp.items;
          this.pagination = resp._meta;
          this.isLoading = false;
        }
      });
  }

  getPublishedForms(): ProFormsAPIResponse[] {
    return this.forms.filter((form) => form.status === 'published');
  }

  searchTermChanged(event: Event) {
    this.searchTerm = (<HTMLInputElement>event.target).value;
    this.searchDebounce();
  }

  searchDebounce() {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
    this.searchTimeout = setTimeout(() => {
      this.currentPage = 1;
      this.getProFormsWithSearchTerm();
    }, 300);
  }

  getProFormsWithSearchTerm() {
    this.proformsFormListService
      .getFormsOnboarding(
        2,
        10,
        this.currentPage,
        undefined,
        undefined,
        this.searchTerm
      )
      .subscribe((resp: GetAllProFormsAPIResponse) => {
        if (resp.items) {
          this.forms = resp.items;
          this.pagination = resp._meta;
          this.isLoading = false;
        }
      });
  }

  pageChange(newPage: number) {
    this.currentPage = newPage;
    this.loadProForms();
  }

  previewForm(formId: number) {
    this.proformsAdminService.getProForm(formId);
    this.previewModal.openModal();
  }
}
